import { Main } from './components';

const ShippingRulePresets = () => <Main />;

export default ShippingRulePresets;
